import { Grid } from "@material-ui/core";
import {
    riskLevelToColor,
    tempExcursionColors,
} from "components/TotalsWidget/colorsMapping";
import TotalWidget from "components/TotalsWidget/TotalWidget";
import { productTypeWidgetFormatting } from "helpers/productTypeStringFormatting";
import { separateThousands } from "helpers/separateThousands";
import { observer } from "mobx-react";
import { RiskLevel } from "models/enums/RiskLevel";
import React from "react";
import { useStore } from "store/StoreConfigs";
import { globalViewStyles } from "./GlobalViewStyles";

export const GlobalViewTotalsWidgetsWrapper = observer(
    function TotalsWidgetsWrapper() {
        const classes = globalViewStyles();
        const defaultSegment = [
            {
                count: 100,
                color: "rgba(240, 241, 249, 1)",
                centerTitle: `No Data`,
                centerSubtitle: `😵`,
            },
        ];
        const defaultExcursionSegment = [
            {
                count: 100,
                color: "rgba(240, 241, 249, 1)",
                centerTitle: `0 Excursions `,
                centerSubtitle: `🎉`,
            },
        ];
        const {
            globalViewStore: {
                aggregations,
                temperatureExcursions,
                loadingAggregations,
                loadingTemperatureExcursions,
            },
        } = useStore();

        const lanesTotal = aggregations.reduce(
            (sum, curr) => sum + curr.countOfLanes,
            0
        );

        const laneHealthSegments = aggregations
            .filter((x) => x.countOfLanes > 0)
            .map((x) => ({
                count: x.countOfLanes,
                color: riskLevelToColor(x.riskLevel),
                centerTitle: `${Math.round(
                    (x.countOfLanes / lanesTotal) * 100
                )}%`,
                centerSubtitle:
                    x.riskLevel === "HEALTHY"
                        ? `No risk`
                        : `${RiskLevel[x.riskLevel].toLowerCase()} risk`,
                tooltipTitle: `${x.countOfLanes}`,
                tooltipSubtitle: x.countOfLanes === 1 ? "Lane" : "Lanes",
            }));

        const shipmentsTotal = aggregations.reduce(
            (sum, curr) => sum + curr.countOfShipments,
            0
        );

        const shipmentHealthSegments = aggregations
            .filter((x) => x.countOfShipments > 0)
            .map((x) => ({
                count: x.countOfShipments,
                color: riskLevelToColor(x.riskLevel),
                centerTitle: `${Math.round(
                    (x.countOfShipments / shipmentsTotal) * 100
                )}%`,
                centerSubtitle:
                    x.riskLevel === "HEALTHY"
                        ? `No risk`
                        : `${RiskLevel[x.riskLevel].toLowerCase()} risk`,
                tooltipTitle: `${x.countOfShipments}`,
                tooltipSubtitle:
                    x.countOfShipments === 1 ? "Shipment" : "Shipments",
            }));

        const tempExcursionsTotal = temperatureExcursions.reduce(
            (sum, curr) => sum + curr.excursionCount,
            0
        );

        const tempExcursionsSegments = temperatureExcursions.map(
            (x, index) => ({
                count: x.excursionCount,
                color: tempExcursionColors[index],
                centerTitle: `${Math.round(
                    (x.excursionCount / tempExcursionsTotal) * 100
                )}%`,
                centerSubtitle: "of excursions",
                tooltipTitle: `${x.excursionCount} ${
                    x.excursionCount === 1 ? "excursion" : "excursions"
                }`,
                tooltipSubtitle: productTypeWidgetFormatting(x.productType),
            })
        );

        return (
            <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                className={classes.section}
            >
                <TotalWidget
                    title="lane health"
                    centerTitle={
                        lanesTotal === 0
                            ? "No Data"
                            : separateThousands(lanesTotal)
                    }
                    centerSubtitle={lanesTotal === 0 ? "😵" : "total lanes"}
                    showTooltips={lanesTotal !== 0}
                    segments={
                        lanesTotal === 0 ? defaultSegment : laneHealthSegments
                    }
                    isLoading={loadingAggregations}
                />
                <TotalWidget
                    title="shipment health"
                    centerTitle={
                        shipmentsTotal === 0
                            ? "No Data"
                            : separateThousands(shipmentsTotal)
                    }
                    centerSubtitle={
                        shipmentsTotal === 0 ? "😵" : "total shipments"
                    }
                    showTooltips={shipmentsTotal !== 0}
                    segments={
                        shipmentsTotal === 0
                            ? defaultSegment
                            : shipmentHealthSegments
                    }
                    isLoading={loadingAggregations}
                />
                <TotalWidget
                    title="shipments impacted by temp excursions"
                    centerTitle={
                        tempExcursionsTotal === 0
                            ? tempExcursionsTotal.toString() + "\nExcursions "
                            : tempExcursionsTotal.toString()
                    }
                    centerSubtitle={
                        tempExcursionsTotal === 0 ? "🎉" : "temp excursions"
                    }
                    showTooltips={tempExcursionsTotal !== 0}
                    segments={
                        tempExcursionsTotal === 0
                            ? defaultExcursionSegment
                            : tempExcursionsSegments
                    }
                    isLoading={loadingTemperatureExcursions}
                />
            </Grid>
        );
    }
);
